module.exports = __webpack_public_path__ + "img/2.6a4ec32b.jpg";